import { render, staticRenderFns } from "./bookerPackages.vue?vue&type=template&id=150aa8fb&scoped=true"
import script from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerPackages.vue?vue&type=style&index=0&id=150aa8fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150aa8fb",
  null
  
)

export default component.exports